import {ITEM_SELECTED, ACTION_GET_TEST_SUCCEEDED, CHAPTER_SELECTED} from "../actions/actionTypes";

export default function (state = [], action) {
    switch (action.type) {
        case ITEM_SELECTED:
            return action.payload;
        case ACTION_GET_TEST_SUCCEEDED:
        case CHAPTER_SELECTED:
            return [];
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/item_active.js